export const API_HEADERS = {
  X_API_CLIENT_ID: 'x-api-client-id',
  AUTHORIZATION: 'Authorization',
} as const
